<template>
  <div class="activity-detail-page">
    <div class="banner banner-2501">
      <Banner loc="3-2" :baseBtn="false"/>
      <!-- <div class="tx-wrap">
        <div class="tx-box">
          <div class="tx1">{{ data.title }}</div>
          <div class="tx2">{{ data.subtitle }}</div>
          <div class="tx3">MOMOOMOMOM</div>
        </div>
        <button class="add-cart-btn" @click="goProductDetail">查看商品</button>
      </div> -->
      <!-- <img class="img-responsive" :src="data.photo" alt /> -->
    </div>
    <div class="breadcrumbs c-layout">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.activity') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{data.name}}</span>
    </div>
    <div class="content c-layout detail-content-dc">
      <div class="date">{{moment(data.createTime).format("MMM DD ddd YYYY")}}</div>
      <div class="title">{{data.name}}</div>
      <div class="desc" v-html="data.content"></div>

      <!-- <div class="tx">
        <p>近年吹起無鋼圈內衣的流行，少了鋼圈的壓迫感，穿上無鋼圈的舒適自在感讓眾多少女們念念不忘，但又害怕</p>
        <p>習慣穿無鋼圈會讓胸部外擴、副乳的問題變得嚴重。</p>
        <p>不過這邊要告訴大家：內衣的設計生產技術已經很進步，即使少了鋼圈，內衣仍然可以透過加強其他的結構來 增加機能性，而且現在無鋼圈內衣款式越來越多，素面無痕的、可愛的、性感的通通有～想要舒適又有機能的 無鋼圈內衣推薦款，看這篇就對了！</p>
        <p style="padding:15px 0;">※ 特別推薦：Huwa無鋼圈內衣</p>
        <p style="padding:15px 0;">這篇要推薦的無鋼圈內衣分成四種類型！女孩們可依照妳們的需求挑選唷！</p>
        <p>素面無痕百搭款：上班襯衫、出遊洋裝都可以穿！</p>
        <p>蕾絲美背款：小露心機、夏季穿搭不二人選！</p>
        <p>下厚上薄爆乳款：小胸救星～打造深v事業線！</p>
        <p>蕾絲薄襯款：性感蕾絲薄襯，隱藏的迷人誘惑！</p>
        <p>以下來分別介紹四種類型的無鋼圈內衣吧！</p>
      </div>-->
    </div>
    <!-- <div class="other-tx c-layout">
      <div class="title">素面無痕無鋼圈推薦 —— 素面百搭！上班襯衫、出遊洋裝都穿它！</div>
      <p>素人激推，從上班OL到孕媽咪，從小罩杯到大罩杯都愛穿的：</p>
    </div> -->
    <div class="banner-2501">
      <div class="tx-wrap">
        <div class="tx-box">
          <div class="tx1">{{ data.title }}</div>
          <div class="tx2">{{ data.subtitle }}</div>
          <!-- <div class="tx3">MOMOOMOMOM</div> -->
        </div>
        <button class="add-cart-btn" @click="goProductDetail">{{ $t('btns.check_product') }}</button>
      </div>
      <!-- <img class="img-responsive" src="./images/img_line_up03@2x.png" alt /> -->
      <img class="img-responsive" :src="data.photo2" alt />
    </div>

    <div class="extra-row c-layout">
      <div class="extra-left" v-html="data.content2">
        <!-- <p class="orange-tx">爆乳無鋼圈推薦 ——下厚上薄爆乳款！</p>
        <p class="orange-tx">小胸救星，打造深v事業線！</p>
        <p style="padding-top:10px;">分別是</p>
        <div class="red-tx">
          <p>【Proj. A】 露蒂莎時光 法式涼感無鋼圈內衣 、</p>
          <p>【Proj.A】 爵妮小姐 法式蕾絲無鋼圈內衣 、</p>
          <p>【A+手捧】蝶舞波蕾 無鋼圈內衣 !</p>
        </div>
        <p>跟上次開箱的感覺一樣，放在手中細緻的觸感，</p>
        <p>完全感受到亞曼菲對內衣品質的堅持。</p>
        <p>畢竟內衣是最貼近身體的私密衣物，</p>
        <p>小娜真心建議大家還是要選擇舒適、質感好點的!</p> -->
      </div>
      <div class="extra-right">
        <!-- <img class="img-responsive" src="./images/mv03_pc.png" alt /> -->
        <img class="img-responsive" :src="data.photo3" alt />
      </div>
    </div>
    <GoodsFlexible :list="recentGoods" :title="$t('goodsFlexible.recent')" sub-title="RECENT" tag="hot" />
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import GoodsFlexible from "@/components/GoodsFlexible";
import { getActivityDetail } from "@/api";
import moment from "moment";
import Mixin from "@/utils/goodsMixin";

export default {
   mixins:[Mixin],
  data() {
    return {
      data: "",
    };
  },
  mounted() {
    let { id } = this.$route.query;
    getActivityDetail({ id }).then((res) => {
      this.data = res.share;
    });
  },
  methods: {
    moment,
    goProductDetail() {
      this.$router.push({ name: "goodsDetail", query: { goods_id: this.data.product_no } });
    }
  },
  components: {
    GoodsFlexible,
    Banner
  },
};
</script>

<style scoped lang='less'>
.activity-detail-page {
  .banner {
    width: 100%;
    // height: 675px;
  }
  .breadcrumbs {
    .p-16 {
      padding: 0 16px;
    }
    .o-color {
      color: var(---unnamed-color-ec4f00);
    }
    padding: 35px 0;
    font-size: 16px;
    line-height: 24px;
    color: var(---unnamed-color-707070);
  }
  .content {
    padding-top: 10px;
    margin-bottom: 85px;
    .tx {
      font-size: 16px;
      line-height: 24px;
      color: var(---unnamed-color-707070);
    }
  }
  .other-tx {
    margin-bottom: 45px;
    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 50px;
      color: var(---unnamed-color-ec4f00);
    }

    p {
      font-size: 16px;
      line-height: 24px;
      color: var(---unnamed-color-707070);
    }
  }
  .banner-2501 {
    width: 100%;
    // height: 650px;
    position: relative;
    .tx-wrap {
      position: absolute;
      bottom: 10%;
      left: 13.8%;
      z-index: 1;
    }
    .tx-box {
      .tx1 {
        font-size: 32px;
        line-height: 50px;
        font-weight: 500;
        color: var(--unnamed-color-ffffff);
      }
      .tx2,
      .tx3 {
        padding-top: 15px;
        font-size: 16px;
        line-height: 24px;
        color: var(--unnamed-color-ffffff);
      }
    }
    .add-cart-btn {
      margin-top: 36px;
      cursor: pointer;
      width: 125px;
      height: 40px;
      background: var(--unnamed-color-ffffff);
      border: 1px solid var(--unnamed-color-ffffff);
      font-size: 13px;
      line-height: 20px;
      color: var(--unnamed-color-000000);
    }
    @media (max-width:992px) {
      .tx-wrap {

      }
      .tx-box {
        .tx1 {
          font-size: 22px;
          line-height: 25px;
          font-weight: 500;
          color: var(--unnamed-color-ffffff);
        }
        .tx2,
        .tx3 {
          padding-top: 5px;
          font-size: 15px;
          line-height: 15px;
          color: var(--unnamed-color-ffffff);
        }
      }
      .add-cart-btn {
        margin-top: 20px;
        width: 100px;
        height: 30px;
      }
    }
  }
  .extra-row {
    display: flex;
    justify-content: space-between;
    padding-top: 47px;
    padding-bottom: 64px;
    .extra-left {
      color: var(---unnamed-color-707070);
      font-size: 16px;
      line-height: 24px;
      .orange-tx {
        font-weight: 500;
        font-size: 24px;
        line-height: 50px;
        color: var(---unnamed-color-ff5214);
      }
      .red-tx {
        color: #8d0000;
      }
    }
    .extra-right {
      width: 540px;
      height: 310px;
    }
  }
  .desc {
    span {
      white-space: break-spaces !important;
    }
  }
}
</style>
